import gql from 'graphql-tag'

export default gql`
mutation CreateScheduleTask($fields: ScheduleTaskCreateInput!) {
  cashAssist {
    createMutation: createScheduleTask(fields: $fields) {
      id: taskId
    }
  }
}`
